import { BasicStorageManager } from '@bridebook/toolbox/src/storage-managers';

export const onboardingFinishedStorage = BasicStorageManager<boolean>({
  storageKey: 'onboarding-finished',
});
